import react, { memo } from 'react';
import IMAGES from '../../constans/images';
import ROUTERS from '../../constans/router';
import { useNavigate } from 'react-router-dom';

type props = {
  handleClick: Function,
  handleClickKakao: Function,
  handleClickDel: Function,
  handleClickPublic: Function,
  isFullScreen: Boolean,
  videoDetail: Object,
  userInfo: Object,
  videoRecommend: Boolean,
  toggleFullScreen: Function,
};

const HeaderMenuVideo = ({
  handleClickPrev,
  handleClickKakao,
  handleClickDel,
  handleClickPublic,
  isFullScreen,
  videoDetail,
  userInfo,
  videoRecommend,
  toggleFullScreen,
}: Props) => {
  const navigate = useNavigate();

  const _toggleFullScreen = () => {
    toggleFullScreen()
  }

  return (
    <div className={`menu-header ${isFullScreen ? 'full-screen' : ''}`}>
      <div className="menu-header__left" onClick={handleClickPrev}>
        <img
          src={'/images/header_prev_w.svg'}
          className={isFullScreen ? 'img-full-prev' : 'img-prev'}
        />
        <div
          className={`menu-header__left__prev`}
        >
          {/* 뽀로로가 {userInfo?.nickname || ''} 에게 보낸 편지 */}
          {videoDetail.video_message?.title || ''}
        </div>
      </div>
      {videoRecommend ? (
        isFullScreen && <div className="menu-header__right">
          <div className="menu-header__right__delete" onClick={_toggleFullScreen}>
              <img
                src={'/images/comment.png'}
              />
            </div>
        </div>
      ) : (
        userInfo.id !== videoDetail.user_id ? null : (
          <div className="menu-header__right">
            {
              !videoDetail?.video_message?.user_published_at && !videoDetail?.video_message?.published_at && isFullScreen && <div className="menu-header__right__public">
                      <img
                        src={`/images/icon_unlock.svg`}
                        onClick={handleClickPublic}
                        className={isFullScreen ? 'img-full-public' : 'img-public'}
                      />
                    </div>
            }
            <div className="menu-header__right__atalk" onClick={handleClickKakao}>
              <img
                src={'/images/icon_kakao.svg'}
                
                className={isFullScreen ? 'img-full-kakao' : 'img-kakao'}
              />
            </div>
            <div className="menu-header__right__delete" onClick={handleClickDel}>
              <img
                src={'/images/icon_delete.svg'}
                
                className={isFullScreen ? 'img-full-delete' : 'img-delete'}
              />
            </div>
            {
              !videoDetail?.video_message?.user_published_at && !videoDetail?.video_message?.published_at && isFullScreen && (
                <div className="gift" onClick={handleClickPublic}>
                <span className="text-gift">
                  영상공개하고 선물받자! 
                </span>
              </div>
              )
            }
          </div>
        )
      )}
      
    </div>
  );
};

HeaderMenuVideo.defaultProps = {
  videoRecommend: false
}

export default memo(HeaderMenuVideo);
